import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { cn } from "@/lib/utils";

const categories = [
  "toate",
  "Detergent rufe albe",
  "Detergent rufe colorate",
  "Detergent rufe negre",
  "Balsam de rufe",
];

export default function Catalog() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Derive the active filter directly from the URL (single source of truth)
  const catParam = searchParams.get("categorie");
  const active = categories.includes(catParam) ? catParam : "toate";

  const selectCategory = (c) => {
    if (c === "toate") setSearchParams({});
    else setSearchParams({ categorie: c });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(true);
    api
      .get("/products", { params: active !== "toate" ? { category: active } : {} })
      .then((res) => setProducts(res.data))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="mx-auto max-w-7xl px-6 py-12 lg:px-12" data-testid="catalog-page">
      <header className="mb-10">
        <span className="label-caps text-sky-600">Catalog</span>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tight text-slate-900 lg:text-5xl">Produsele noastre</h1>
        <p className="mt-3 max-w-xl text-slate-600">Detergenți și balsamuri concentrate de 4L, în trei parfumuri sofisticate.</p>
      </header>

      <div className="mb-8 flex flex-wrap gap-2.5" data-testid="category-filters">
        {categories.map((c) => (
          <button
            key={c}
            onClick={() => selectCategory(c)}
            data-testid={`filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
            className={cn(
              "rounded-full border px-5 py-2 text-sm font-semibold transition-all",
              active === c
                ? "border-sky-600 bg-sky-600 text-white"
                : "border-slate-200 bg-white text-slate-600 hover:border-sky-300 hover:text-sky-600"
            )}
          >
            {c === "toate" ? "Toate" : c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-80 animate-pulse rounded-2xl bg-slate-100" />
          ))}
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
